import { ReactElement } from 'react'
import PagamentoRepository from 'modules/pagamentos/infra/repositories/PagamentoRepository'

import ComprovanteTransferenciaImpl from '../../domain/usecases/ComprovanteTransferencia'
import GetCartoes from '../../domain/usecases/GetCartoes'
import TransferenciaRepository from '../../infra/repositories/TransferenciaRepository'
import VerifyPasswordImpl from '../../domain/usecases/VerifyPassword'
import Transferencia from '../../pages/Transferencia'

export const TransferenciaFactory = (): ReactElement => {
  const pagamentoRepository = new PagamentoRepository()
  const transferenciaRepository = new TransferenciaRepository()
  const comprovanteTransferenciaImpl = new ComprovanteTransferenciaImpl(
    transferenciaRepository,
  )
  const getCartao = new GetCartoes(pagamentoRepository)
  const verifyPassword = new VerifyPasswordImpl(pagamentoRepository)

  return (
    <Transferencia
      comprovanteTransferencia={comprovanteTransferenciaImpl}
      getCartao={getCartao}
      verifyPassword={verifyPassword}
    />
  )
}

export default TransferenciaFactory
